import { FC } from 'react';

import HTMLContent from '@telialt/common-html-content/src';
import { useSelectedProductVariant } from '@telialt/core-eshop/src/hooks/useSelectedProductVariant';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

export const Summary: FC = () => {
    const productVariant = useSelectedProductVariant();

    return (
        productVariant?.summary && (
            <HTMLContent dataTest={ESHOP_TEST_ID.ESHOP_PRODUCT_SUMMARY} content={productVariant?.summary} />
        )
    );
};
